import { styled } from '@stitches/react';
import { createTransition } from '@/utils/css/css';

export const IconButton = styled('button', {
  borderRadius: '50%',
  transition: createTransition(
    ['color', 'background-color', 'border-color'],
    '0.15s',
    'ease-in-out'
  ),

  variants: {
    size: {
      small: {
        width: 32,
        height: 32,
      },
      medium: {
        width: 40,
        height: 40,
      },
    },
    variant: {
      secondary: {
        color: '$textPrimary',
        backgroundColor: '$surfaceSecondary',

        '&:hover, &:focus-visible': {
          backgroundColor: '$surfaceTertiary',
        },

        '&:disabled': {
          color: '$textDisabled',
          backgroundColor: '$surfaceSecondary',
        },
      },
      quaternary: {
        color: '$textPrimary',
        backgroundColor: 'transparent',

        '&:hover, &:focus-visible': {
          backgroundColor: '$surfaceSecondary',
        },

        '&:disabled': {
          color: '$textDisabled',
        },
      },
    },
    cursor: {
      pointer: {
        cursor: 'pointer',
      },
      grab: {
        cursor: 'grab',
        touchAction: 'none',
      },
    },
  },
  defaultVariants: {
    size: 'medium',
    variant: 'secondary',
    cursor: 'pointer',
  },
});
